import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/test',
        name: 'test',
        component: () => import('../views/tianbao/specialty/index.vue'),
    },
    {
        path: '/assess',
        name: 'assess',
        component: () => import('../views/assess/interest.vue'),
    },

    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login'),
    },
    {
        path: '/report',
        name: 'report',
        component: () => import('../views/tianbao/report/download.vue'),
    },
    {
        path: "/College",
        component: () => import("../views/search-college/college.vue"),
        children: [
            {
                path: "",
                name: "CollegeInfo",
                component: () => import("../views/search-college/info"),
            },
            {
                path: '/solution',
                name: 'solution',
                meta: '招生简章详情',
                component: () => import('../views/search-college/solution.vue')
            },
            {
                path: "score",
                name: "score",
                component: () => import("../views/search-college/score"),
            },
            {
                path: "specialty",
                name: "specialty",
                component: () => import("../views/search-college/specialty"),
            },


        ]
    },



    {
        path: '/report_tiqian',
        name: 'report_tiqian',
        component: () => import('../views/tianbao/report/report_tiqian.vue'),
    },
    {
        path: '/',
        name: '',
        component: () => import('../views/index'),
        children: [
            {
                path: '',
                component: () => import('../views/user/index'),
                children: [
                    {
                        path: '',
                        name: 'backstage',
                        component: () => import('../views/user/backstage.vue'),
                    },
                    {
                        path: 'user/website',
                        name: 'website',
                        component: () => import('../views/user/website.vue'),
                    },
                ]
            },
        ]
    },

    {
        path: '/tianbao',
        component: () => import("../views/tianbao/index"),
        children: [
            {
                path: '',
                name: 'benke',
                component: () => import('../views/tianbao/benke'),
            },
            {
                path: 'zhuanke',
                name: 'zhuanke',
                component: () => import('../views/tianbao/zhuanke'),
            },
            {
                path: 't_zhuanke',
                name: 't_zhuanke',
                component: () => import('../views/tianbao/t_zhuanke'),
            },
            {
                path: 't_benke',
                name: 't_benke',
                component: () => import('../views/tianbao/t_benke'),
            },
        ]
    },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    routes
});


router.beforeEach((to, from, next) => {
    console.log(to.name)
    // to: Route: 即将要进入的目标 路由对象
    // from: Route: 当前导航正要离开的路由
    // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    const ExpertInfo = localStorage.getItem('ExpertInfo') // 是否登录
    // 未登录状态；当路由到nextRoute指定页时，跳转至login


    if (to.name === 'login' || to.name === 'assess') {
        next()
        return
    }

    if (!ExpertInfo) {
        router.push('/login')
    } else {
        next()
    }
    // // // 已登录状态；当路由到login时，跳转至home

    // next();
})

export default router
